import { destroy, get, patch, post, submitFormData } from "./ServicesApi";

// Upload/replace a client's logo (#283 follow-up) — multipart to the authed
// endpoint; the image is then served publicly at /public-routes/client-logo/:id.
const uploadClientLogo = (id, file) => {
  const formData = new FormData();
  formData.append("logo", file);
  return submitFormData(`/v1/client/${id}/logo`, formData);
};

const createClient = (body) => {
  const clientPromise = post("/v1/client", body);
  return clientPromise;
};

const editClientData = (id, body) => {
  const clientPromise = patch(`/v1/client/${id}`, body);
  return clientPromise;
};

const createClientType = (body) => {
  const clientTypePromise = post("/v1/client-type", body);
  return clientTypePromise;
};

const updateClientTypeData = (id, body) => {
  const clientTypePromise = patch(`/v1/client-type/${id}`, body);
  return clientTypePromise;
};

const getClients = (params) => {
  const clientPromise = get("/v1/client", { params });
  return clientPromise;
};

const updateMultiClients = (body) => {
  const clientPromise = patch(`/v1/client/multi-update/`, body);
  return clientPromise;
};

const getClientNicknames = (clientId) => {
  return get(`/v1/client/${clientId}/nicknames`);
};

const createClientNickname = (clientId, nickname) => {
  return post(`/v1/client/${clientId}/nicknames`, { nickname });
};

const deleteClientNickname = (clientId, nicknameId) => {
  return destroy(`/v1/client/${clientId}/nicknames/${nicknameId}`);
};

export {
  getClients,
  createClient,
  createClientType,
  editClientData,
  updateMultiClients,
  updateClientTypeData,
  getClientNicknames,
  createClientNickname,
  deleteClientNickname,
  uploadClientLogo,
};
